export const initialErrorData = {
  email: '',
  address: '',
  phone_number: '',
  name: '',
  surname: '',
};

// `POST /workers/upload_cv` answers 422 with this `error_code` when the CV holds the profiles of
// more than one person (a joint CV, or a template's sample page left in). Neither the
// missing-fields form nor uploading the same file again can help: only a CV with one person in it.
export const CV_MULTIPLE_PROFILES_ERROR_CODE = 'cv_multiple_profiles';

// Same endpoint, same 422, when the PDF carries a real open password. Nothing can read it: not
// the parser, not the employer's browser. The backend refuses it outright rather than storing a
// document that would reach an employer as a password prompt, so the only way forward is a file
// with the protection removed.
export const CV_PASSWORD_PROTECTED_ERROR_CODE = 'cv_password_protected';

// Each refusal gets its own sentence, because each one asks for something different and none of
// them is fixed by uploading the same file again — which is all the generic "we could not read
// your CV" message invites. Kept here rather than in the component so the pairing between a code
// and its copy can be asserted without standing up the React tree.
export const CV_REFUSALS: Record<string, { messageKey: string; testId: string }> = {
  [CV_MULTIPLE_PROFILES_ERROR_CODE]: {
    messageKey: 'the_cv_contains_more_than_one_profile,upload_a_cv_with_only_yours',
    testId: 'upload-cv-multiple-profiles-error',
  },
  [CV_PASSWORD_PROTECTED_ERROR_CODE]: {
    messageKey: 'the_cv_is_password_protected,remove_the_protection_and_upload_it_again',
    testId: 'upload-cv-password-protected-error',
  },
};
